import React, { FC } from 'react';
import { Icon } from '@firesoon/antd';
import { UploadImgBtnProps } from './interface';
import './index.less';

const Index: FC<UploadImgBtnProps> = ({
  loading = false,
  uploadText = '图片',
}) => {
  return (
    <div className="fs-upload-img">
      <Icon type={loading ? 'loading' : 'plus'} />
      <div className="ant-upload-text">{loading ? '正在上传' : uploadText}</div>
    </div>
  );
};

export default Index;